import { path } from 'ramda'
import React from 'react'

import { TO_GROUP } from '../_constants/assignConstants'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import GroupSelect from '../../../../containers/groups/select/GroupSelect'

const GroupAssign = () => {
  const form = useForm()
  const { handleChange } = useFormState()

  if (form.assign !== TO_GROUP) return false

  return <GroupSelect multiple value={form?.userOrGroup || []} onChange={handleChange('userOrGroup')} />
}

export default GroupAssign
